/*
ForegroundObjectVisibilityDetail.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {Button, Checkbox, FormGroup, InputGroup, Popover, Tag, H5} from '@blueprintjs/core';


/*

Props (required):
	selected			- should not be null

*/


export class ForegroundObjectVisibilityDetail extends React.Component {


	constructor(props) {
		super(props);

		this.handleSetShouldRestrictVisibilityByTime = this.handleSetShouldRestrictVisibilityByTime.bind(this);
		this.handleSetTime = this.handleSetTime.bind(this);
		this.handleAddNewInterval = this.handleAddNewInterval.bind(this);
		this.handleDeleteIntervalWithId = this.handleDeleteIntervalWithId.bind(this);
		this.handleOpenPopover = this.handleOpenPopover.bind(this);
		this.handleClosePopover = this.handleClosePopover.bind(this);

		// The begin and end objects have these properties:
		//	value 		- a number (may be NaN)
		//	str 			- the corresponding string representation
		//	isValid 	- true if values is not NaN and is finite

		this.state = {
			begin: this.getTimeObjectForStr("6"),
			end: this.getTimeObjectForStr("18"),
			isPopoverOpen: false,
		};
	}


	handleSetShouldRestrictVisibilityByTime(value) {
		if (this.props.selected === null) {
			console.error('Attempt to set shouldRestrictVisibilityByTime when there is no selected object.');
			return;
		}
		this.props.selected.setShouldRestrictVisibilityByTime(value);
	}

	handleSetTime(name, str) {
		// This is used to handle the text input for both the beginning and ending fields.
		this.setState({[name]: this.getTimeObjectForStr(str)});
	}	

	handleAddNewInterval() {
		this.setState({isPopoverOpen: false});
		if (this.props.selected === null) {
			console.error('Attempt to add new visibility interval when there is no selected object.');
			return;
		}
		let begin = this.state.begin;
		let end = this.state.end;
		if (begin.isValid && end.isValid) {
			this.props.selected.addNewTimesVisibleInterval(begin.value, end.value);
		} else {
			console.error('Attempt to add new visibility interval with invalid arguments.');
		}
	}

	handleDeleteIntervalWithId(id) {
		if (this.props.selected === null) {
			console.error('Attempt to delete a visibility interval when there is no selected object.');
			return;
		}
	
		let timesVisible = this.props.selected.getTimesVisible();

		let index = timesVisible.findIndex(item => (item.id === id));
		if (index < 0) {
			console.error('Could not find the visibility interval to delete.');
			return;
		}

		this.props.selected.deleteTimesVisibleIntervalAtIndex(index);
	}

	handleOpenPopover() {
		this.setState({isPopoverOpen: true});	
	}

	handleClosePopover() {
		this.setState({isPopoverOpen: false});
	}

	getTimeObjectForStr(str) {
		let strFixed = parseFloat(str).toFixed(2);
		let value = parseFloat(strFixed);
		let isValid = (!Number.isNaN(value) && Number.isFinite(value));
		return {value: value, str: str, isValid: isValid};
	}
	
	getHourString(time) {
		return (Math.round(time * 100))/100;
	}
	
	render() {

		if (this.props.selected === null) {
			console.error('render called on ForegroundObjectVisibilityDetail with null value for selected.');
			return (<p>Error.</p>);
		}

		let list;
		let timesVisibleArr = this.props.selected.getTimesVisible();
		if (timesVisibleArr.length === 0) {
			list = (<p>...</p>);
		} else {
			list = [];
			for (let i = 0; i < timesVisibleArr.length; ++i) {
				let interval = timesVisibleArr[i];
				list.push((	<Tag key={interval.id} minimal large round onRemove={() => this.handleDeleteIntervalWithId(interval.id)}
											style={{margin: "4px 4px"}}>
												{this.getHourString(interval.beginHour)} to {this.getHourString(interval.endHour)}
										</Tag>
				));
			}
		}

		let isRestricted = this.props.selected.getShouldRestrictVisibilityByTime();

		let beginInputIntent = this.state.begin.isValid ? "none" : "danger";
		let endInputIntent = this.state.end.isValid ? "none" : "danger";

		let disableAddInterval = !(this.state.begin.isValid && this.state.end.isValid);

		return (
			<div>

				<Checkbox label="Restrict Visibility By Time"
					checked={isRestricted}
					onChange={e => this.handleSetShouldRestrictVisibilityByTime(e.target.checked)}
					style={{margin: "20px 0 20px 0"}}
				/>

				<div style={{display: "flex", alignItems: "center"}}>

					<Popover isOpen={this.state.isPopoverOpen} onClose={this.handleClosePopover}>
						<Button style={{flex: "1 1 0"}} onClick={this.handleOpenPopover}>Add Interval</Button>
						<div style={{margin: "0", padding: "25px", width: "30em", backgroundColor: "white"}}>
	
							<H5>Define New Visibility Interval</H5>

							<em style={{display: "block", width: "100%"}}>Beginning and ending times should be given in decimal hours, using a 24 hour clock. Wrap-around is allowed.</em>

							<div style={{margin: "15px 0 25px 0", display: "flex", justifyContent: "center", width: "100%"}}>

							<FormGroup label="Begin" labelFor="begin-time-input" style={{margin: "0 15px", width: "8em", display: "inline-block"}}>
								<InputGroup id="begin-time-input" onChange={(e) => this.handleSetTime('begin', e.target.value)}
									intent={beginInputIntent} value={this.state.begin.str} />
							</FormGroup>

							<FormGroup label="End" labelFor="end-time-input" style={{margin: "0 15px", width: "8em", display: "inline-block"}}>
								<InputGroup id="end-time-input" onChange={(e) => this.handleSetTime('end', e.target.value)}
									intent={endInputIntent} value={this.state.end.str} />
							</FormGroup>

							</div>

							<Button intent="primary" style={{position: "relative", left: "50%", transform: "translateX(-50%)"}}
								disabled={disableAddInterval} onClick={this.handleAddNewInterval} >
									Add New Visibility Interval
							</Button>

						</div>
					</Popover>

					<div style={{display: "inline-block", margin: "20px 0 20px 20px", border: "1px solid #e0e0e0", padding: "10px", flex: "2 1 0"}}>
						<p style={{margin: 0}}>Times when visible:</p>
						<div style={{padding: "6px 20px"}}>
							{list}
						</div>
					</div>

				</div>

			</div>
		);
	}	

}


